// extracted by mini-css-extract-plugin
export var backdropBlur = "_fq-0";
export var contentCard = "_fq-5";
export var frame = "_fq-2";
export var image = "_fq-4";
export var imagePane = "_fq-3";
export var modal = "_fq-1";